<div class="container-fluid bg-dark text-light upperHeader shadow">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <div class="adminPhone"><a routerLink="/admin" [routerLinkActive]="'active'"><i class="fa fa-user-circle-o fs-3"
            aria-hidden="true"></i></a>
      </div>
      <div class="col-lg-3">
        <a routerLink="/" [routerLinkActive]="'active'" class="text-decoration-none">
          <h3 class="text-warning fs-3 mt-2">PetMe</h3>
        </a>
      </div>
      <nav (click)="toggleClass()" class="text-end col-lg-9 d-flex justify-content-end shadow"
        [class.mobileNavActive]="classApplied">
        <a routerLink="/" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact:true}"><i class="fa fa-home"
            aria-hidden="true"></i>
          Home</a>
        <a routerLink="/dogs" [routerLinkActive]="'active'"><i class="fa fa-paw" aria-hidden="true"></i>
          Dogs</a>
        <a routerLink="/contact" [routerLinkActive]="'active'"><i class="fa fa-envelope" aria-hidden="true"></i>
          Contact</a>
        <a *ngIf="!isLoggedIn" routerLink="/login"><i class="fa fa-sign-in" aria-hidden="true"></i>
          Login</a>
        <a *ngIf="!isLoggedIn" routerLink="/signup"><i class="fa fa-user-plus" aria-hidden="true"></i>
          Sign Up</a>
        <a (click)="logOut()" *ngIf="isLoggedIn" routerLink="/"><i class="fa fa-sign-out" aria-hidden="true"></i>
          Logout</a>
        <a *ngIf="isLoggedIn" class="adminDesktop" routerLink="/admin"><i class="fa fa-user-circle-o fs-4"
          aria-hidden="true"></i>
          </a>
      </nav>
      <div class="mobileMenu" (click)="toggleClass()"><i class="fa fa-bars fs-2" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</div>
<!-- Hero - Cover image,title btn ... -->
<div class="container-fluid d-flex hero align-items-center text-white shadow">
  <div class="col text-center ">
    <h1  data-aos="zoom-in" data-aos-duration="1500" class="display-1 textShadow">PetMe Association</h1>
    <h6 class="textShadow" data-aos="fade-in" data-aos-duration="2500">Best Friends Animal Society</h6>
    <button (click)="scrolldown()" class="customBtn mt-4" data-aos="fade-up" data-aos-duration="1500" >Scroll Down</button>
  </div>

<div class="scrollToTop" (click)="scrollTop()"><i class="fa fa-hand-o-up" aria-hidden="true"></i></div>

</div>